import React from 'react'
import ReportCard from './ReportCard'
import { PageTitle } from '../../../layout/core'

const Index = () => {
  return (
    <div>
      <PageTitle breadcrumbs={[]}>Reports</PageTitle>
      <ReportCard />
    </div>
  )
}

export default Index
